import Styled from 'styled-components';

const namespace = 'create-loading';

export const CreateLoadingContainer = Styled.div`
  width: 750px;
  text-align: center;

  ${(props: { isMobile?: boolean }) => props.isMobile && (
    'width: auto; text-align: center;'
  )}

  .${namespace}-gif {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 112px;
    margin: 48px 0;

    ion-img::part(image) {
      border-radius: 20px;
    }

    ${(props: { isMobile?: boolean }) => props.isMobile && (
      'display: inline-block; width: 30%; height: 60px; margin: 32px 0;'
    )}
  }

  .${namespace}-body {
    padding: 16px 0;
    text-align: center;
  }
`;
